( function () {
   
    'use strict';
    ( function ( $ ) {
               
        $('.all-product-slider-box').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed: 2000,
            arrows:true,
          
        });
    } )(jQuery);
} )();

